module.exports = __webpack_public_path__ + "img/Russia1.b1e1a383.png";